import React from 'react';

export const IntroductionPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Welcome to Haptic Music Player</h1>
      
      <p className="text-gray-600 dark:text-gray-400 mb-8">
        Experience music in a whole new way with haptic feedback technology. Our player combines
        high-quality audio playback with innovative haptic responses, creating an immersive
        listening experience.
      </p>

      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold mb-4">Key Features</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-600 dark:text-gray-400">
            <li>Haptic feedback synchronized with your music</li>
            <li>Support for local music files and Spotify integration</li>
            <li>Customizable keyboard shortcuts</li>
            <li>Smart playlist management</li>
            <li>Beautiful and responsive design</li>
            <li>Dark mode support</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">Getting Started</h2>
          <p className="text-gray-600 dark:text-gray-400">
            To begin using the Haptic Music Player:
          </p>
          <ol className="list-decimal list-inside space-y-2 mt-2 text-gray-600 dark:text-gray-400">
            <li>Add your local music files or connect your Spotify account</li>
            <li>Explore the interface and customize your settings</li>
            <li>Learn the keyboard shortcuts for efficient control</li>
            <li>Create playlists and organize your music</li>
            <li>Enable haptic feedback for an enhanced experience</li>
          </ol>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">Need Help?</h2>
          <p className="text-gray-600 dark:text-gray-400">
            Check out our detailed documentation sections for more information about specific features,
            or reach out to our support team if you need assistance.
          </p>
        </section>
      </div>
    </div>
  );
};
